import * as React from 'react';
import { FieldArray, useField } from 'formik';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/DeleteOutline';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import {
  TextField,
} from '../form';

export default function Addendums({ name, ...props }) {
  const [field] = useField({ name, ...props });
  return (
    <FieldArray
      {...field}
      render={(arrayHelpers) => (
        <div>
          {field.value && field.value.length > 0 ? (
            field.value.map((item, index) => (
              <Box key={index} style={{ padding: '0 0 1rem' }}>
                <TextField
                  name={`${name}.${index}`}
                />
                <IconButton
                  onClick={() => arrayHelpers.remove(index)}
                >
                  <DeleteIcon />
                </IconButton>
                <IconButton
                  onClick={() => arrayHelpers.insert(index, '')}
                >
                  <AddCircleOutlineIcon />
                </IconButton>
              </Box>
            ))
          ) : (
            <IconButton type="button" onClick={() => arrayHelpers.push('')}>
              <AddCircleOutlineIcon />
            </IconButton>
          )}
        </div>
      )}
    />
  );
}
